export function transformAudit(audit) {
  return {
    text: audit.auditString,
    links: audit.links || [],
    createdAt: audit.createdTime,
    id: audit.id,
    owner: audit.createdById,
    oldValue: audit.oldValue || '',
    newValue: audit.newValue || '',
    showDetails: audit.showDetails || false,
    fieldType: audit.fieldType || '',
  }
}

export function transformTransition(transition) {
  return {
    id: transition.id,
    transitionType: transition.transitionType,
    transitionFieldId: transition.transitionFieldId,
    performerId: transition.performerId,
    oldTransitionFieldId: transition.oldTransitionFieldId,
    duration: transition.duration,
    createdAt: transition.createdTime,
    newTransitionFieldName: transition.newTransitionFieldName,
    oldTransitionFieldName: transition.oldTransitionFieldName,
    performerName: transition.performerName,
  }
}
